/**
 * Returns a key identifying the newer build in `remote`, or null when there is none.
 * `running` (the build this tab loaded) and `remote` are `{ buildTime, version }`. An unknown running build
 * (both fields empty) never counts as outdated.
 */
export const newerBuildKey = (running, remote) => {
    if (!remote) return null;
    if (running?.buildTime && remote.buildTime && running.buildTime !== remote.buildTime) {
        return `${remote.buildTime}|${remote.version ?? ""}`;
    }
    if (running?.version && remote.version && running.version !== remote.version) {
        return `${remote.buildTime ?? ""}|${remote.version}`;
    }
    return null;
};
